export function SplashScreen() {
  return (
    <div className="flex h-dvh w-full items-center justify-center bg-white px-10">
      <svg
        viewBox="0 0 261 74"
        className="w-full max-w-54 motion-safe:animate-[splashHueRotate_15s_linear_infinite]"
        // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role
        role="img"
        aria-label="Mash"
        style={{ willChange: "filter" }}
      >
        <defs>
          <linearGradient
            id="mash-grad"
            x1="0"
            y1="0"
            x2="261"
            y2="74"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#8876D0" />
            <stop offset="50%" stopColor="#4A4598" />
            <stop offset="100%" stopColor="#252040" />
          </linearGradient>
          <mask id="mash-mask">
            <path
              fill="white"
              d="M92.8073 24.2642C92.8073 26.8924 92.5031 28.9153 92.0987 31.1382L84.297 71.7785H71.1255L79.2313 30.2276C79.5355 28.61 79.6358 27.2959 79.6358 26.3853C79.6358 19.4096 75.1784 16.3761 69.3022 16.3761C63.4259 16.3761 58.7646 19.9149 57.1434 28.1029L48.6332 71.7767H35.4617L43.6677 30.2258C43.9719 28.9118 43.9719 27.4959 43.9719 26.4853C43.9719 19.6114 39.5146 16.3761 33.6383 16.3761C28.0662 16.3761 23.2027 19.8131 21.5815 28.1029L13.0713 71.7767H0L8.61222 26.7906C11.5504 11.2215 21.7837 4.34756 33.2321 4.34756C42.2487 4.34756 48.8354 7.98631 52.0777 14.4568C56.637 7.78455 63.5261 4.34756 71.4297 4.34756C83.7906 4.34756 92.809 11.0198 92.809 24.2642H92.8073Z"
            />
            <path
              fill="white"
              d="M136.679 63.5904C132.728 69.859 126.243 73.0943 119.05 73.0943C107.804 73.0943 96.3555 65.3097 96.3555 50.0442C96.3555 34.7786 109.021 20.5237 126.345 20.5237C140.327 20.5237 151.167 29.3188 151.167 43.7755C151.167 45.7966 150.965 47.7178 150.559 49.8407L146.202 71.7784H135.056L136.677 63.5904H136.679Z"
            />
            <path
              fill="black"
              d="M138.908 44.7861C138.908 36.7998 133.741 31.7452 125.637 31.7452C115.81 31.7452 108.919 39.1244 108.919 48.4266C108.919 56.4129 114.086 61.8727 122.394 61.8727C132.526 61.8727 138.908 53.6847 138.908 44.7878V44.7861Z"
            />
            <path
              fill="white"
              d="M189.871 36.1927C189.669 33.261 187.035 31.0364 181.461 31.0364C176.294 31.0364 173.558 33.0575 173.558 35.9892C173.558 39.528 177.509 40.6403 182.778 41.9544C189.465 43.6737 198.988 46.3019 198.988 56.4111C198.988 67.8344 190.376 73.0925 177.913 73.0925C165.45 73.0925 156.333 67.3291 156.333 57.0182H168.492C168.492 60.3551 171.937 62.6798 178.421 62.6798C184.095 62.6798 186.831 60.7587 186.831 57.827C186.831 53.9847 182.374 52.9741 177.713 51.7618C170.315 49.8407 161.401 47.516 161.401 37.6086C161.401 26.1853 169.811 20.5237 181.665 20.5237C193.52 20.5237 201.928 26.3871 201.928 36.1945H189.871V36.1927Z"
            />
            <path
              fill="white"
              d="M219.557 0H231.716L226.446 27.4976C230.399 23.0501 235.26 20.5219 240.732 20.5219C252.383 20.5219 260.591 28.61 260.591 40.8421C260.591 43.3702 260.287 45.6949 259.882 47.8178L255.223 71.7784H242.962L247.825 46.909C248.13 45.3931 248.23 44.079 248.23 42.7649C248.23 35.5875 243.569 31.7452 236.577 31.7452C230.397 31.7452 224.825 35.6875 223.102 44.4826L217.732 71.7784H205.573L219.557 0Z"
            />
          </mask>
        </defs>

        <rect
          width="261"
          height="74"
          fill="url(#mash-grad)"
          mask="url(#mash-mask)"
        />
      </svg>
    </div>
  );
}
